import { Subsection } from "components/layout";
import { urlRegex } from "utils/validation";

import styles from "./SubsectionWithLink.scss";
import { TechnicalText } from "./TechnicalText";

export type SubsectionWithLinkProps = {
  header: string;
  href: string | null | undefined;
};

export function SubsectionWithLink({ header, href }: SubsectionWithLinkProps) {
  if (!href || !urlRegex.test(href)) {
    return (
      <Subsection header={header}>
        <TechnicalText>{href}</TechnicalText>
      </Subsection>
    );
  }

  return (
    <Subsection header={header}>
      <a
        className={styles.link}
        href={href}
        rel="nofollow noopener noreferrer"
        target="_blank"
      >
        {href}
      </a>
    </Subsection>
  );
}
